import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { isEmpty, uniqueId } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';

import { QualityIcon } from '../../../assets/svg/Icon';

import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);
const initPath = `/${process.env.REACT_APP_PATH}`;

export default function WaterQualityList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    datas, handleWaterQualityDetailList, handleOpenLegend, mobilemode,
  } = props;

  function renderList(dataList, boxClass) {
    return (
      <>
        {dataList.map((row) => (
          <Grid item key={uniqueId()}>
            <Box className={`${classes.listsBox} ${boxClass}`}>{row.name}</Box>
          </Grid>
        ))}
      </>
    );
  }

  function renderData(yellow, red, darkRed) {
    return (
      <>
        {renderList(darkRed, classes.darkRed)}
        {renderList(red, classes.red)}
        {renderList(yellow, classes.yellow)}
      </>
    );
  }
  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewQuality}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                {datas.count !== 0
                  ? (
                    <IconButton
                      id="main-wq-click"
                      onClick={mobilemode ? null : handleWaterQualityDetailList(datas)}
                    >
                      <StyledBadge
                        badgeContent={datas.count}
                        overlap="circular"
                        color="secondary"
                      >
                        <QualityIcon style={{ color: 'white' }} />
                      </StyledBadge>
                    </IconButton>
                  ) : (
                    <StyledBadge
                      badgeContent={datas.count}
                      overlap="circular"
                      color="secondary"
                    >
                      <QualityIcon style={{ color: 'white' }} />
                    </StyledBadge>
                  )}
              </Box>
              <Box display="flex" alignItems="center">
                <Box pl={1}>
                  <IconButton
                    id="legend-waterquality"
                    className={classes.btn}
                    onClick={handleOpenLegend(t('เกณฑ์คุณภาพน้ำ'), 'waterquality')}
                  >
                    <InfoIcon type="button" style={{ fontSize: 13, color: '#777' }} />
                  </IconButton>
                </Box>
                <Box p={1}>
                  <NavLink id="navigate_waterquality" to={`${initPath}waterquality`} activeClassName="nav-active">
                    <Typography className={classes.titleBox}>{t('คุณภาพน้ำ')}</Typography>
                  </NavLink>
                </Box>
                <Box><Typography className={classes.timeBox}>{datas.time}</Typography></Box>
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_waterquality_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                {isEmpty(datas) ? null
                  : (
                    <>
                      {(
                        datas.yellow.length <= 0
                        && datas.red.length <= 0
                        && datas.darkRed.length <= 0
                      )
                        ? (
                          <Grid item>
                            <Box
                              className={`${classes.listsBox}`}
                              style={{ backgroundColor: '#FFFFFF90', fontWeight: 'bold' }}
                            >
                              {t('ปกติ')}
                            </Box>
                          </Grid>
                        ) : renderData(datas.yellow, datas.red, datas.darkRed)}
                    </>
                  )}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
WaterQualityList.defaultProps = {
  mobilemode: false,
};

WaterQualityList.propTypes = {
  datas: PropTypes.objectOf(Object).isRequired,
  handleWaterQualityDetailList: PropTypes.func.isRequired,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
